import BackgroundImage from 'assets/images/first-place-bg.png'
import SecondPlaceIcon from 'assets/images/icon-second-place.svg'
import ThirdPlaceIcon from 'assets/images/icon-third-place.svg'

import { FC } from 'react';
// Models
import IResult from 'models/Result';
// Utilities
import { buildUserName } from 'utilities/Utilities';
import { useTranslation } from 'react-i18next';

type Props = {
  secondResult: IResult;
  thirdResult: IResult;
}

const SecondAndThirdPlaces:FC<Props> = ({ secondResult, thirdResult }) => {
  const { t } = useTranslation('common');

  return (
    <div
      className="relative overflow-hidden border-2 rounded-3xl w-full flex justify-between mt-4 xl:mt-24"
      style={{
        borderColor: 'rgba(255,255,255,0.6)',
        background: `linear-gradient(0deg, rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${BackgroundImage}) left / contain no-repeat` 
      }}
    >
      <div className="w-3/6 p-2 border-r py-12 xl:py-20" style={{ borderColor: 'rgba(255,255,255,0.2)' }}>
        <img src={SecondPlaceIcon} className="h-12 mx-auto mt-4 mb-12 sm:h-32" alt="second-place-logo" />
        <h3 className="text-lg font-bold text-center mb-4 sm:text-5xl">{t('quiz.liveLeaderboardPage.secondPlace')}</h3>
        {!!secondResult && (
          <>
            <h2 className="text-sm font-bold text-center uppercase sm:text-4xl">{buildUserName(secondResult)}</h2>
            <h4 className="text-sm font-bold text-center sm:text-4xl">{`${secondResult.score} ${t('quiz.liveLeaderboardPage.points')}`}</h4>
          </>
        )}
      </div>
      <div className="w-3/6 p-2 py-12 xl:py-20">
        <img src={ThirdPlaceIcon} className="h-12 mx-auto mt-4 mb-12 sm:h-32" alt="third-place-logo" />
        <h3 className="text-lg font-bold text-center mb-4 sm:text-5xl">{t('quiz.liveLeaderboardPage.thirdPlace')}</h3>
        {!!thirdResult && (
          <>
            <h2 className="text-sm font-bold text-center uppercase sm:text-4xl">{buildUserName(thirdResult)}</h2>
            <h4 className="text-sm font-bold text-center sm:text-4xl">{`${thirdResult.score} ${t('quiz.liveLeaderboardPage.points')}`}</h4>
          </>
        )}
      </div>
    </div>
  )
}

export default SecondAndThirdPlaces;
